// extracted by mini-css-extract-plugin
export default {"departments":"XH-z","departmentHeading":"YH-z","departmentSection":"ZH-z","departmentName":"_H-z","departmentLink":"aI-z","expandIcon":"bI-z"};